// extracted by mini-css-extract-plugin
export default {"body":"Major_body__LnIgs","rightTotal":"Major_rightTotal__WElYW"};